import { PoultryItem } from "./types";
import { Button } from "@/components/ui/button";
import { RotateCcw, Trash2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const getPoultryColumns = (
  onLossClick: (item: PoultryItem) => void,
  onReturnClick: (item: PoultryItem) => void
) => [
  {
    id: "race",
    label: "Race",
    cell: (row: PoultryItem) => row.data.Race || row.data.name || "-",
  },
  {
    id: "quantity",
    label: "Quantité",
    cell: (row: PoultryItem) => row.quantity || 0,
  },
  {
    id: "unit",
    label: "Unité",
    cell: (row: PoultryItem) => row.data.Unité || "Tête",
  },
  {
    id: "age",
    label: "Âge",
    cell: (row: PoultryItem) => row.data.Age || "-",
  },
  {
    id: "health",
    label: "État de santé",
    cell: (row: PoultryItem) => row.data.Santé || "-",
  },
  {
    id: "weight",
    label: "Poids moyen",
    cell: (row: PoultryItem) => row.data.Poids || "-",
  },
  {
    id: "diet",
    label: "Régime alimentaire",
    cell: (row: PoultryItem) => row.data.Régime || "-",
  },
  {
    id: "actions",
    label: "Actions",
    cell: (row: PoultryItem) => {
      const handleDelete = async () => {
        try {
          // 1. Get all transactions for this stock item
          const { data: transactions, error: transactionsError } = await supabase
            .from('poultry_transactions')
            .select('id')
            .eq('stock_item_id', row.id);

          if (transactionsError) throw transactionsError;

          // 2. Delete credit payments associated with these transactions
          if (transactions && transactions.length > 0) {
            const transactionIds = transactions.map(t => t.id);
            const { error: creditPaymentsError } = await supabase
              .from('credit_payments')
              .delete()
              .in('transaction_id', transactionIds);

            if (creditPaymentsError) throw creditPaymentsError;
          }

          // 3. Delete the transactions
          const { error: transactionsDeleteError } = await supabase
            .from('poultry_transactions')
            .delete()
            .eq('stock_item_id', row.id);

          if (transactionsDeleteError) throw transactionsDeleteError;

          // 4. Delete associated losses
          const { error: lossesError } = await supabase
            .from('stock_losses')
            .delete()
            .eq('stock_item_id', row.id);

          if (lossesError) throw lossesError;

          // 5. Delete breeding cycles
          const { error: cyclesError } = await supabase
            .from('poultry_breeding_cycles')
            .delete()
            .eq('stock_item_id', row.id);

          if (cyclesError) throw cyclesError;

          // 6. Delete egg productions
          const { error: eggsError } = await supabase
            .from('egg_productions')
            .delete()
            .eq('stock_item_id', row.id);

          if (eggsError) throw eggsError;

          // 7. Delete cart items
          const { error: cartError } = await supabase
            .from('cart_items')
            .delete()
            .eq('stock_item_id', row.id);

          if (cartError) throw cartError;

          // 8. Finally, delete the stock item
          const { error: deleteError } = await supabase
            .from('stock_items')
            .delete()
            .eq('id', row.id);

          if (deleteError) throw deleteError;

          toast.success("Race supprimée avec succès");
          window.location.reload();
        } catch (error: any) {
          console.error("Erreur lors de la suppression:", error);
          toast.error("Erreur lors de la suppression de la race");
        }
      };

      return (
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onReturnClick(row)}
            className="flex items-center gap-1 text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50"
          >
            <RotateCcw className="h-4 w-4" />
            Retour
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleDelete}
            className="flex items-center gap-1 text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <Trash2 className="h-4 w-4" />
            Supprimer
          </Button>
        </div>
      );
    },
  },
];